//@ts-nocheck
import { t } from '@web-solutions/module-localization';

import { Text } from 'core/ui-elements';

import { Base } from '../base';

import classes from '../../style.module.scss';

const tKey = 'core.subscription.error_popup.decline_reasons.card_issuer_email_footer';

interface Props {
  onClick: () => void;
}

export const CardIssuerEmailFooter: React.FC<Props> = ({ onClick }) => {
  return (
    <Base subtitle={t(`${tKey}.subtitle`)} withButton withFooter onClick={onClick}>
      <Text
        className={classes.baseText}
        components={{
          email: (
            <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} className={classes.email} />
          ),
        }}
        tOptions={{ email: `${process.env.REACT_APP_SUPPORT_EMAIL}` }}
      >
        {`${tKey}.text`}
      </Text>
    </Base>
  );
};
